var styles = {"box":"ForgotPassword_box_1n164_1","disabled":"ForgotPassword_disabled_1n164_15","v2":"ForgotPassword_v2_1n164_19"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
